(function () {

    angular
        .module('smartertoolsApp')
        .controller('accountCardsOnFileController',
            [
                '$scope', '$timeout', 'cardsOnFileService', 'notificationFactory', 'payment', 'myAccountService', 'accountService', 'payments', '$q',
                accountCardsOnFileController
            ]);

    function accountCardsOnFileController($scope, $timeout, cardsOnFileService, notify, angularPaymentService, myAccountService, accountService, paymentsService, $q) {
        const vm = this;
        vm.cards = null;
        vm.isSaving = false;
        vm.isDeleting = false;
        vm.countryList = geographicLocations.countries;
        vm.stateList = geographicLocations.statesByCountry;
        vm.areaPermissions = myAccountService.areaPermissions;

        // Functions
        vm.Reload = Reload;
        vm.attachFocusEvent = attachFocusEvent;
        vm.viewCard = viewCard;
        vm.addCard = addCard;
        vm.saveCard = saveCard;
        vm.deleteCard = deleteCard;
        vm.doDeleteCard = doDeleteCard;
        vm.formattedCardNumber = formattedCardNumber;
        vm.cardTypeName = cardTypeName;
        vm.isExpired = isExpired;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.Reload();
        }

        function Reload() {
            $scope.accountCtrl.isLoading++;
            $q
                .all(
                    [
                        cardsOnFileService.getCardsOnFile(),
                        accountService.getAccountSettings()
                    ])
                .then((values) => {
                    $scope.accountCtrl.isLoading--;
                    vm.cards = values[0].Cards;
                    vm.showAutoCharge = values[0].ShowAutoCharge;
                    vm.autoChargePaymentMethodId = values[0].autoChargePaymentMethodId;
                    vm.accountDetails = values[1];
                    $timeout(() => RecalculateAllFloatLabelControls());
                })
                .catch(function () {
                    $scope.accountCtrl.isLoading--;
                    notify.error('There was a problem loading this information.  Please try again later.');
                });
        }

        function attachFocusEvent() {
            if (!vm.focusEventAttached) {
                document.getElementById('account-card-view')
                    .addEventListener('shown.bs.modal', () => {
                        const ccNumber = document.getElementById('CCNumber');
                        const ccName = document.getElementById('CCName');

                        if (ccNumber.offsetParent !== null) {
                            ccNumber.focus();
                        } else {
                            ccName.focus();
                        }
                    });
                vm.focusEventAttached = true;
            }
        }

        function viewCard(card) {
            vm.selectedCard = angular.copy(card);
            vm.isSaving = false;
            vm.isDeleting = false;
            vm.attachFocusEvent();
            vm.CardViewForm.$setPristine();
            vm.CardViewForm.$setUntouched();
            $timeout(() => {
                bootstrap.Modal.getOrCreateInstance(document.getElementById('account-card-view')).show();
                RecalculateAllFloatLabelControls();
            }, 25);
        }

        function addCard() {
            if (vm.accountDetails && vm.accountDetails.Details) {
                vm.selectedCard = {
                    ExpirationMonth: new Date().getMonth() + 1 + '',
                    ExpirationYear: new Date().getFullYear() + 1 + '',
                    Country: vm.accountDetails.Details.AddressCountryCode,
                    Address1: vm.accountDetails.Details.AddressStreet1,
                    Address2: vm.accountDetails.Details.AddressStreet2,
                    City: vm.accountDetails.Details.AddressCity,
                    State: vm.accountDetails.Details.AddressState,
                    ZipCode: vm.accountDetails.Details.AddressZip
                };
            } else {
                vm.selectedCard = {
                    ExpirationMonth: new Date().getMonth() + 1 + '',
                    ExpirationYear: new Date().getFullYear() + 1 + '',
                    Country: 'US'
                };
            }
            vm.isSaving = false;
            vm.isDeleting = false;
            vm.attachFocusEvent();
            vm.CardViewForm.$setPristine();
            vm.CardViewForm.$setUntouched();
            $timeout(() => {
                bootstrap.Modal.getOrCreateInstance(document.getElementById('account-card-view')).show();
                RecalculateAllFloatLabelControls();
            }, 25);
        }

        function saveCard() {
            if (vm.CardViewForm.$invalid)
                return;
            vm.isSaving = true;

            const dt = new Date(vm.selectedCard.ExpirationYear, vm.selectedCard.ExpirationMonth - 1, 1);
            const dtMoment = moment(dt);
            dtMoment.add(1, 'months');

            const isExpired = dtMoment.isBefore(new Date());
            if (isExpired) {
                notify.error('You cannot save an expired card.');
                return;
            }

            cardsOnFileService.saveCard(vm.selectedCard)
                .then(() => {
                    vm.isSaving = false;
                    notify.success('Card was updated.');
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('account-card-view')).hide();
                    paymentsService.clearPaymentMethodsCache();
                    vm.Reload();
                })
                .catch(() => {
                    vm.isSaving = false;
                    notify.error('There was a problem updating the item.');
                });
        }

        function deleteCard() {
            if (vm.selectedCard.PaymentMethodId)
                vm.isDeleting = true;
        }

        function doDeleteCard() {
            vm.isSaving = true;
            cardsOnFileService.deleteCard(vm.selectedCard)
                .then(() => {
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('account-card-view')).hide();
                    vm.isDeleting = false;
                    vm.isSaving = false;
                    notify.success('Card was deleted');
                    paymentsService.clearPaymentMethodsCache();
                    vm.Reload();
                })
                .catch((err) => {
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('account-card-view')).hide();
                    vm.isDeleting = false;
                    vm.isSaving = false;
                    if (err && err.statusText)
                        notify.error('This card cannot be deleted.  ' + err.statusText);
                    else
                        notify.error('There was a problem updating the item.');
                });
        }

        function formattedCardNumber(firstTwo, lastFour) {
            if (firstTwo && firstTwo[0] == '3')
                return firstTwo + '<span class=smaller-text>xx&nbsp;xxxxxx&nbsp;x</span>' + lastFour;
            else
                return firstTwo + '<span class=smaller-text>xx&nbsp;xxxx&nbsp;xxxx&nbsp;</span>' + lastFour;
        }

        function cardTypeName(item) {
            const fullNumber = item.FirstTwo + '0000000000' + item.LastFour;
            const type = angularPaymentService.cardFromNumber(fullNumber);
            if (type && type.type == 'amex')
                return 'American Express';
            if (type && type.type == 'visa')
                return 'Visa';
            if (type && type.type == 'mastercard')
                return 'MasterCard';
            if (type && type.type == 'discover')
                return 'Discover';
            return 'Credit Card';
        }

        function isExpired(expires) { return new Date(expires) < new Date(); }
    }

})();